import React, { useState, useEffect } from 'react';
import axios from 'axios';
import "../rest/RestoForm.css";
import { Typography, Tabs, Tab, Box, Alert } from '@mui/material';

const RestForm = () => {
  const [users, setUsers] = useState([]);
  const [contractors, setContractors] = useState([]);
  const [restaurants, setRestaurants] = useState([]);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [activeTab, setActiveTab] = useState(0);
  const [formData, setFormData] = useState({
    user_id: '',
    contractor_id: '',
    restaurant_id: '',
    contractor_name: '',
    restaurant_name: '',
    uid: '',
    type: 'solo'
  });
  const [values, setValues] = useState({
    username: "",
    email: "",
    password: "",
    confirmPassword: "",
    region: "uk-UA",
    token: "" 
  });
  
  const [userHasContractor, setUserHasContractor] = useState(false);
  const [emailAlreadyExists, setEmailAlreadyExists] = useState(false);
  const [usernameAlreadyExists, setUsernameAlreadyExists] = useState(false);
  const [passwordMatch, setPasswordMatch] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        await Promise.all([
          fetchUsers(),
          fetchContractors(),
          fetchRestaurants()
        ]);
      } catch (error) {
        console.error('Error fetching data:', error);
        setError('Помилка при завантаженні даних');
      }
    };
    
    fetchData();
  }, []);

  const fetchUsers = async () => {
    try {
      // ЗМІНЕНО: Використовуємо правильний ендпоінт для отримання юзерів
      const { data } = await axios.get('https://hub2.daolog.net/users');
      console.log('Fetched users:', data);
      setUsers(data);
    } catch (error) {
      console.error('Error fetching users:', error);
      setError('Помилка при завантаженні користувачів');
      throw error;
    }
  };

  const fetchContractors = async () => {
    try {
      const { data } = await axios.get('https://hub2.daolog.net/contractors');
      setContractors(data);
    } catch (error) {
      setError('Помилка при завантаженні контрагентів');
      throw error;
    }
  };

  const fetchRestaurants = async () => {
    try {
      const { data } = await axios.get('https://hub2.daolog.net/restaurants');
      setRestaurants(data);
    } catch (error) {
      setError('Помилка при завантаженні ресторанів');
      throw error;
    }
  };

  const checkUserContractor = async (userId) => {
    try {
      const { data } = await axios.get(`https://hub2.daolog.net/check-user-contractor/${userId}`);
      setUserHasContractor(data.hasContractor);
      if (data.hasContractor) {
        setError('У співробітника вже є контрагент');
        setSuccess('');
      } else {
        setError('');
      }
    } catch (error) {
      console.error('Error checking user contractor:', error);
      setError('Помилка при перевірці контрагента');
      setSuccess('');
    }
  };

  const handleChange = ({ target: { name, value } }) => {
    setFormData(prev => ({ ...prev, [name]: value }));
    if (name === 'user_id') {
      checkUserContractor(value);
    }
    setError('');
    setSuccess('');
  };

  const handleRegisterChange = (event) => {
    setValues({ ...values, [event.target.name]: event.target.value });
    setError('');
    setSuccess('');
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (userHasContractor) {
      setError('У співробітника вже є контрагент');
      setSuccess('');
      return;
    }
    if (!formData.user_id) {
      setError('Будь ласка, виберіть співробітника');
      setSuccess('');
      return;
    }
    try {
      await axios.post('https://hub2.daolog.net/add-contractor-to-user', {
        user_id: parseInt(formData.user_id),
        contractor_name: formData.contractor_name,
      });
      
      await fetchContractors();
      setFormData(prev => ({ ...prev, contractor_name: '' }));
      setError('');
      setSuccess('компанію успішно додано до співробітника');
    } catch (error) {
      setError(error.response?.data?.message || 'Помилка при додаванні контрагента');
      setSuccess('');
    }
  };

  const handleRegisterSubmit = async (event) => {
    event.preventDefault();
    
    if (values.password !== values.confirmPassword) {
      setPasswordMatch(false);
      setError('Паролі не співпадають');
      setSuccess('');
      return;
    }
    
    try {
      const userData = {
        username: values.username,
        email: values.email,
        password: values.password,
        region: values.region || 'uk-UA',
        token: values.token  
      };
  
      const res = await axios.post("https://hub2.daolog.net/signup", userData);
      
      setSuccess('співробітника успішно зареєстровано');
      setError('');
      
      // Оновлюємо список користувачів
      await fetchUsers();
      
      // Скидаємо форму
      setValues({
        username: "",
        email: "",
        password: "",
        confirmPassword: "",
        region: "uk-UA",
        token: ""
      });
      
    } catch (error) {
      console.error('Registration error:', error);
      setError(error.response?.data?.message || 'Помилка при реєстрації співробітника');
      setSuccess('');
    }
  };
  
  const handleAddRestaurant = async (event) => {
    event.preventDefault();
    try {
      await axios.post('https://hub2.daolog.net/add-restaurant-to-contractor', {
        contractor_id: formData.contractor_id,
        restaurant_name: formData.restaurant_name,
        uid: formData.uid,
      });

      await fetchRestaurants();
      setFormData(prev => ({ ...prev, restaurant_name: '', uid: '' }));
      setSuccess('Ресторан успішно додано');
      setError('');
    } catch (error) {
      setError(error.response?.data?.message || 'Помилка при додаванні ресторану');
      setSuccess('');
    }
  };

  const handleAddContractor = async (event) => {
    event.preventDefault();
    try {
      const response = await axios.post('https://hub2.daolog.net/add-contractor', {
        name: formData.contractor_name,
        type: formData.type
      });
  
      console.log('Created contractor:', response.data);
      
      await fetchContractors();
      
      setFormData(prev => ({ ...prev, contractor_name: '', type: 'solo' }));
      setSuccess('компанію успішно створено');
      setError('');
    } catch (error) {
      setError(error.response?.data?.message || 'Помилка при створенні контрагента');
      setSuccess('');
    }
  };

  const renderAddUserContractorForm = () => (
    <form onSubmit={handleSubmit}>
      {(error || success) && (
        <Alert 
          severity={error ? "error" : "success"} 
          style={{ marginBottom: "10px" }}
        >
          {error || success}
        </Alert>
      )}
      <select
        className="input-stl"
        style={{ marginTop: "10px", backgroundColor: "rgb(213, 220, 255)", width: '100%', padding: '8px' }}
        name="user_id"
        value={formData.user_id}
        onChange={handleChange}
        required
      >
        <option value="">Виберіть співробітника</option>
        {users.map((user) => (
          <option key={user.id} value={user.id}>
            {user.username || user.email} (ID: {user.id})
          </option>
        ))}
      </select>
      <select
        className="input-stl"
        style={{ marginTop: "10px", backgroundColor: "rgb(213, 220, 255)", width: '100%', padding: '8px' }}
        name="contractor_name"
        value={formData.contractor_name}
        onChange={handleChange}
        disabled={userHasContractor}
        required
      >
        <option value="">Виберіть або введіть нового компанію</option>
        {Array.from(new Set(contractors.map(c => c.name))).map(name => (
          <option key={name} value={name}>{name}</option>
        ))}
      </select>
      <button
        className="input-stl"
        style={{ 
          marginTop: "15px", 
          width: '100%',
          padding: '10px',
          backgroundColor: userHasContractor ? '#ccc' : '#4CAF50',
          color: 'white',
          border: 'none',
          borderRadius: '4px',
          cursor: userHasContractor ? 'not-allowed' : 'pointer'
        }}
        type="submit"
        disabled={userHasContractor}
      >
        Додати компанію до співробітника
      </button>
    </form>
  );

  const renderAddNewContractorForm = () => (
    <form onSubmit={handleAddContractor}>
      {(error || success) && (
        <Alert 
          severity={error ? "error" : "success"} 
          style={{ marginBottom: "10px" }}
        >
          {error || success}
        </Alert>
      )}
      <input
        className="input-stl"
        style={{ 
          marginTop: "10px", 
          backgroundColor: "rgb(213, 220, 255)",
          width: '100%',
          padding: '8px',
          boxSizing: 'border-box'
        }}
        type="text"
        name="contractor_name"
        value={formData.contractor_name}
        onChange={handleChange}
        placeholder="Назва нового компанію"
        required
      />
      <select
        className="input-stl"
        style={{ 
          marginTop: "10px", 
          backgroundColor: "rgb(213, 220, 255)",
          width: '100%',
          padding: '8px',
          boxSizing: 'border-box'
        }}
        name="type"
        value={formData.type}
        onChange={handleChange}
        required
      >
        <option value="solo">Solo</option>
        <option value="chain">Chain</option>
      </select>
      <button
        className="input-stl"
        style={{ 
          marginTop: "15px",
          width: '100%',
          padding: '10px',
          backgroundColor: '#4CAF50',
          color: 'white',
          border: 'none',
          borderRadius: '4px',
          cursor: 'pointer'
        }}
        type="submit"
      >
        Додати нового компанію
      </button>
    </form>
  );

  const renderAddNewUserForm = () => (
    <form onSubmit={handleRegisterSubmit}>
      {(error || success) && (
        <Alert 
          severity={error ? "error" : "success"} 
          style={{ marginBottom: "10px" }}
        >
          {error || success}
        </Alert>
      )}
      
      <div style={{ width: '100%', maxWidth: '400px', margin: '0 auto' }}>
        <div style={{ marginBottom: '15px' }}>
          <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>
            Username:
          </label>
          <input
            className="input-stl"
            style={{
              width: '100%',
              padding: '8px',
              boxSizing: 'border-box',
              backgroundColor: "rgb(213, 220, 255)",
              border: '1px solid #ccc',
              borderRadius: '4px'
            }}
            placeholder="Username"
            type="text"
            name="username"
            value={values.username}
            onChange={handleRegisterChange}
            required
          />
        </div>

        <div style={{ marginBottom: '15px' }}>
          <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>
            Email:
          </label>
          <input
            className="input-stl"
            style={{
              width: '100%',
              padding: '8px',
              boxSizing: 'border-box',
              backgroundColor: "rgb(213, 220, 255)",
              border: '1px solid #ccc',
              borderRadius: '4px'
            }}
            placeholder="Email"
            type="email"
            name="email"
            value={values.email}
            onChange={handleRegisterChange}
            required
          />
        </div>
        
        <div style={{ marginBottom: '15px' }}>
          <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>
            Password:
          </label>
          <input
            className="input-stl"
            style={{
              width: '100%',
              padding: '8px',
              boxSizing: 'border-box',
              backgroundColor: "rgb(213, 220, 255)",
              border: '1px solid #ccc',
              borderRadius: '4px'
            }}
            placeholder="Password"
            type="password"
            name="password"
            value={values.password}
            onChange={handleRegisterChange}
            required
          />
        </div>
        
        <div style={{ marginBottom: '15px' }}>
          <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>
            Confirm Password:
          </label>
          <input
            className="input-stl"
            style={{
              width: '100%',
              padding: '8px',
              boxSizing: 'border-box',
              backgroundColor: "rgb(213, 220, 255)",
              border: '1px solid #ccc',
              borderRadius: '4px'
            }}
            placeholder="Confirm Password"
            type="password"
            name="confirmPassword"
            value={values.confirmPassword}
            onChange={handleRegisterChange}
            required
          />
        </div>
        
        <div style={{ marginBottom: '15px' }}>
          <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>
            Токен:
          </label>
          <input
            className="input-stl"
            style={{
              width: '100%',
              padding: '8px',
              boxSizing: 'border-box',
              backgroundColor: "rgb(213, 220, 255)",
              border: '1px solid #ccc',
              borderRadius: '4px'
            }}
            placeholder="Токен"
            type="text"
            name="token"
            value={values.token}
            onChange={handleRegisterChange}
          />
        </div>
        
        <button
          className="input-stl"
          type="submit"
          style={{
            width: '100%',
            padding: '10px',
            backgroundColor: '#4CAF50',
            color: 'white',
            border: 'none',
            borderRadius: '4px',
            cursor: 'pointer',
            fontSize: '16px',
            fontWeight: 'bold'
          }}
        >
          Створити нового співробітника
        </button>
      </div>
    </form>
  );

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
    setError('');
    setSuccess('');
    setFormData({
      user_id: '',
      contractor_id: '',
      restaurant_id: '',
      contractor_name: '',
      restaurant_name: '',
      uid: '',
      type: 'solo'
    });
    setValues({
      username: "",
      email: "",
      password: "",
      confirmPassword: "",
      region: "uk-UA",
      token: ""
    });
    setEmailAlreadyExists(false);
    setUsernameAlreadyExists(false);
    setPasswordMatch(true);
  };

  return (
    <div className="br-m">
      <div className="container-about-ll">
        <Typography variant="h5" gutterBottom style={{ textAlign: 'center', marginBottom: '20px' }}>
          Управління компаніюми та ресторанами
        </Typography>
        
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <Tabs 
            value={activeTab} 
            onChange={handleTabChange}
            centered
          >
            <Tab label="Додати компанію до співробітника" />
            <Tab label="Додати компанію" />
            <Tab label="Додати нового співробітника" />
          </Tabs>
        </Box>

        <Box sx={{ padding: 3 }}>
          {activeTab === 0 && (
            <Box>
              <Typography variant="h6" gutterBottom>
                Додати компанію до існуючого співробітника
              </Typography>
              {renderAddUserContractorForm()}
            </Box>
          )}
          
          {activeTab === 1 && (
            <Box>
              <Typography variant="h6" gutterBottom>
                Створити нового компанію
              </Typography>
              {renderAddNewContractorForm()}
            </Box>
          )}
          
          {activeTab === 2 && (
            <Box>
              <Typography variant="h6" gutterBottom>
                Створити нового співробітника
              </Typography>
              {renderAddNewUserForm()}
            </Box>
          )}
        </Box>
      </div>
    </div>
  );
};

export default RestForm;